<template>
  <div>
    <!-- 筛选条件 start -->
    <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
      <el-form-item label="">
        <el-input v-model="keywords.purchasecompany" @keyup.enter.native="clickSearch" placeholder="请输入采购单位"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="keywords.projectname" @keyup.enter.native="clickSearch" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="keywords.bomname" @keyup.enter.native="clickSearch" placeholder="请输入物料名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="keywords.bomsn" @keyup.enter.native="clickSearch" placeholder="请输入物料编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clickSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <!-- 筛选条件 end -->

    <!-- 数据列表 start -->
    <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
      <el-table-column prop="Orderid" label="合同编号" width="200"></el-table-column>
      <el-table-column prop="Contractamount" label="合同金额" width="100"></el-table-column>
      <el-table-column prop="PayAmountYes" label="已申请付款金额" width="150"></el-table-column>
      <el-table-column prop="PayAmountNo" label="未申请付款金额" width="150"></el-table-column>
      <!-- <el-table-column prop="Purchasecompany" label="采购单位" width="300"></el-table-column> -->
      <el-table-column prop="Projectname" label="项目名称" width="200"></el-table-column>
      <el-table-column prop="Bomname" label="物料名称" width="300"></el-table-column>
      <el-table-column prop="Suppliername" label="供应商名称" width="300"></el-table-column>
      <el-table-column prop="Contractnum" label="合同数量" width="100"></el-table-column>
      <!-- <el-table-column prop="Createtime" label="签订时间" width="200"></el-table-column> -->
      <el-table-column prop="operation" label="操作" width="200" fixed="right">
        <template v-slot="scope">
          <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickFuKuanShenQing(scope.row)">付款申请</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 数据列表 end -->

    <!-- 付款申请 start -->
    <el-dialog title="付款申请" :visible.sync="dialogFuKuanShenQing" width="600px">
      <el-form :model="modelFuKuanShenHe" ref="addMechanismRef" label-width="150px">
<!--        <el-form-item label="申请单位" class="addAdminForm">
          <el-input v-model="modelFuKuanShenHe.shenqingdanwei" placeholder="请输入申请单位"></el-input>
        </el-form-item> -->
        <el-form-item label="申请时间" class="addAdminForm">
          <el-date-picker v-model="modelFuKuanShenHe.shenqingshijian" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同付款条件" class="addAdminForm">
          <el-select v-model="modelFuKuanShenHe.paymentid" placeholder="请选择合同付款条件" class="select2" @change="selectPayment()">
            <el-option
              v-for="item in paymentList" :key="item.Id" :label="item.Paymentterms" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同付款时间" class="addAdminForm">
          {{modelFuKuanShenHe.paymenttime}}
        </el-form-item>
        <el-form-item label="合同付款金额" class="addAdminForm">
          {{modelFuKuanShenHe.paymentamount}}
        </el-form-item>
        <el-form-item label="本次申请付款金额" class="addAdminForm">
          <el-input v-model="modelFuKuanShenHe.amount" placeholder="请输入本次申请付款金额"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSubmit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 付款申请 end -->

    <!-- 分页 -->
    <div class="pages">
      <el-pagination
        @current-change="handleCurrentPageChange"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="dataListnum"
        :current-page.sync="selectedPageNo">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      paymentList: [],
      modelFuKuanShenHe: {
        orderid: '',
        shenqingdanwei: '',
        shenqingshijian: '',
        paymentid: '',
        paymentterms: '',
        paymenttime: '',
        paymentamount: '',
        amount: ''
      },
      // 查询
      keywords: {
        begintime: '',
        endtime: '',
        purchasecompany: '',
        projectname: '',
        bomname: '',
        bomsn: '',
        reviewstatus: '5'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogFuKuanShenQing: false
    }
  },
  mounted () {
    this.apiGetErp6PurchaseOrderNum()
    this.apiGetErp6PurchaseOrderList()
  },
  methods: {
    clickFuKuanShenQing(row){
      this.modelFuKuanShenHe.orderid = row.Orderid
      this.modelFuKuanShenHe.shenqingdanwei = row.Purchasecompany
      this.paymentList = row.Sublist
      this.dialogFuKuanShenQing = true
    },
    selectPayment(){
      this.paymentList.forEach(obj => {
        if(this.modelFuKuanShenHe.paymentid == obj.Id){
          this.modelFuKuanShenHe.paymentterms = obj.Paymentterms
          this.modelFuKuanShenHe.paymenttime = obj.Paymenttime
          this.modelFuKuanShenHe.paymentamount = obj.Paymentamount
        }
      });
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6PurchaseOrderNum()
      this.apiGetErp6PurchaseOrderList()
    },
    clickSubmit () {
      this.apiAddErp6PurchaseOrderFuKuanShenHe()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6PurchaseOrderList()
    },
    apiGetErp6PurchaseOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        reviewstatus: that.keywords.reviewstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6PurchaseOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        reviewstatus: that.keywords.reviewstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6PurchaseOrderFuKuanShenHe: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.modelFuKuanShenHe.orderid,
        shenqingdanwei: that.modelFuKuanShenHe.shenqingdanwei,
        shenqingshijian: that.modelFuKuanShenHe.shenqingshijian,
        paymentterms: that.modelFuKuanShenHe.paymentterms,
        paymenttime: that.modelFuKuanShenHe.paymenttime,
        paymentamount: that.modelFuKuanShenHe.paymentamount,
        amount: that.modelFuKuanShenHe.amount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6PurchaseOrderFuKuanShenHe, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
